{
  "name": "Tariff",
  "dbName": "tariff",
  "columns": [
    {
      "fieldName": "priority",
      "dbName": "priority",
      "displayName": "Priority",
      "dataType": "INTEGER"
    },
    {
      "fieldName": "fromTime",
      "dbName": "from_date",
      "displayName": "From Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "toTime",
      "dbName": "to_date",
      "displayName": "To Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "description",
      "dbName": "description",
      "displayName": "Description",
      "dataType": "STRING"
    },
    {
      "fieldName": "modifiedBy",
      "dbName": "modified_by",
      "displayName": "Modified By",
      "dataType": "STRING",
      "styleConfig": {
        "type" : "user-avatar"
      }
    },
    {
      "fieldName": "modifiedDate",
      "dbName": "modified_date",
      "displayName": "Modified Date",
      "dataType": "DATETIME"
    }
  ]
}
